export const SIZE_FILE_MEGAS = '10 Megabytes';
export const SIZE_FILE_AVATAR_MEGAS = '5 Megabytes';
